/**
 * GIMmanager SignalRHub Events.
 */
export const GIMevents = {
  MAP: {
    OBJECT: {
      INSERTED_ON_MAP: 'SendtoJS_ObjectLocationFileAdded',
      PRELOAD_PROGRESS: 'SendToJS_GIMmapAddProgress',
    },
  },
  PRO: {
    OBJECT: {
      UPLOAD_PROGRESS: 'SendToJS_object_upload_progress',
      DOWNLOAD_PROGRESS: 'SendToJS_object_download_progress',
      UPLOAD_RESULT: 'SendToJS_object_upload_result',
      DOWNLOAD_RESULT: 'SendToJS_object_download_result',
      CREATION_RESULT: 'SendToJS_object_creation_result',
      JSON_DOWNLOAD_PROGRESS: 'SendToJS_JSON_download_progress',
    },
  },
};
